<div class="w-100 d-flex flex-wrap container">
  <div class="w-100 d-flex flex-wrap align-items-center justify-content-between header">
    <p class="title">سفارش‌های درانتظار</p>

    <ngx-button
      [style]="'link'"
      [size]="'small'"
      [leftIcon]="{
        name: 'arrow-2-left',
        type: 'linear',
      }"
      (clickHandler)="goToTransactionsHandler()"
    >
      بیشتر
    </ngx-button>
  </div>

  <div class="w-100 mt-small d-flex flex-wrap">
    <ngx-segmented-control
      [mode]="'PAGE_SEGMENT'"
      [options]="options()"
      [selectedOption]="options()[0]"
      (change)="updateFilterHandler($event); activeSegment.set($event.id)"
      class="w-100 segment-style"
    >
    </ngx-segmented-control>
    <div class="w-100 d-flex flex-wrap segment-content">
      @if (loadingTransactions()) {
        <app-spinner />
      } @else {
        @if (transactions().length > 0) {
          @if (activeSegment() === 'Buy') {
            <ngx-alert
              [size]="'sm'"
              class="w-100 mb-medium"
              [color]="'gray'"
              [text]="'این مبالغ در کل دارایی شما محاسبه نمی‌شود.'"
              [hasCloseIcon]="false"
            />
          }
          <div class="w-100 total-amount d-flex">
            @if (type() === 'Sell') {
              <p>
                @if (canSee()) {
                  {{ totalUnits() | number }}
                } @else {
                  <span> ********* </span>
                }
                واحد
              </p>
            } @else {
              <p>
                @if (canSee()) {
                  {{ totalAmount() | thousands }}
                } @else {
                  <span> ****** </span>
                }

                ریال
              </p>
            }
          </div>
          <div
            class="w-100 d-flex flex-wrap transactions-container"
            [ngClass]="{ 'overlapping-transactions': transactions().length >= 4 }"
          >
            @for (transaction of transactions(); track $index) {
              <wealth-applet-pending-transaction-card
                class="w-100 transaction"
                [transaction]="transaction"
                [canSee]="canSee()"
                [from]="'portfo'"
              />
            }
          </div>
        } @else {
          <wealth-applet-pending-transaction-empty
            [state]="state()"
            class="w-100"
          />
        }
      }
    </div>
  </div>
</div>
